<div class="alumni-wrapper">
  <h2>Our Hall of Fame</h2>
  <div
    class="alumni-marquee"
    [ngClass]="{
      'mobile-view': isMobile
    }"
  >
    <div
      class="alumni-track"
      [ngClass]="{
        'scroll-animation': alumniList.length >= 4 && !isMobile,
        'display-column': alumniList.length < 4 || isMobile
      }"
    >
      <div class="alumni-item" *ngFor="let alumni of alumniList">
        <div class="image-wrapper">
          <!-- <img [src]="alumni.url" /> -->
          <div
            class="background-image"
            [style.background-image]="'url(' + alumni.url + ')'"
          ></div>
          <div class="layer2" [style.background-color]="alumni.color"></div>
        </div>
        <div class="wrapper">
          <h3>{{ alumni.name }} ({{ alumni.batch }})</h3>
          <p>{{ alumni.designation }}</p>
        </div>
      </div>
      <ng-container *ngIf="alumniList.length >= 4 && !isMobile">
        <div class="alumni-item" *ngFor="let alumni of alumniList">
          <div class="image-wrapper">
            <!-- <img [src]="alumni.url" /> -->
            <div
              class="background-image"
              [style.background-image]="'url(' + alumni.url + ')'"
            ></div>
            <div
              class="layer2"
              [style.background-color]="alumniList.color"
            ></div>
          </div>
          <div class="wrapper">
            <h3>{{ alumni.name }} ({{ alumni.batch }})</h3>
            <p>{{ alumni.designation }}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
